import React, {useEffect, useState} from 'react';
import {Policy} from '../../../../component/policy';
import Form from "../../../../component/visit-application/visitor-form";
import Api from "../../../../interface/api/visit";
import {EducationComponent, EducationComponentForSld} from "../../../../component/visit-application/extends/education";
import {VisitorHistoryViewComponent} from "../../../../component/visit-application/visitor-history";
import {Link} from "react-router-dom";
import {constructVisitorInfo, VisitorInfo} from "../../../../interface/model/visitor";
import VisitApi from "../../../../interface/api/visit";

export function VisitApplication(props) {
    const { history } = props;
    const [ step, setStep ] = useState<number>(0);
    const [ visitorInfo, setVisitorInfo ] = useState<VisitorInfo>({
        ...constructVisitorInfo, standardFlag:true
    });
    const [ visitorTermsInfos, setVisitorTermsInfos ] = useState();

    function nextStepHandler() {
        setStep(step+1);
    }

    function policyCompleteHandler(visitorTermsInfos) {
        setVisitorTermsInfos(visitorTermsInfos);
        setStep(step+1);
    }

    function completeHandler(visitorInfo) {
        history.push('/visit/history/'+visitorInfo.seq);
    }

    return (
        <div className="nv_contents">
            <h2 className="nv_subtit" id="top">내방신청</h2>
            <ul className="nv_step">
                <li className={step === 0 ? 'on' :  ''}>약관동의</li>
                <li className={step === 1 ? 'on' :  ''}>방문신청 정보입력</li>
                <li className={step === 2 ? 'on' :  ''}>완료</li>
            </ul>
            <div className="nv_step_contents">
                {step === 0 && <Policy visitorInfo={visitorInfo} setVisitorInfo={setVisitorInfo} nextStepHandler={policyCompleteHandler}/>}
                {step === 1 && <Form props={props} visitorTermsInfos={visitorTermsInfos} visitorInfo={visitorInfo} completeHandler={completeHandler}/>}
                {step === 2 && <Complete visitorInfo={visitorInfo}/>}
            </div>
        </div>
    )
}

// 신청 이후 추가정보 입력 경로
export function VisitorApplicationExtends(props) {
    const {history, match} = props;
    const [ step, setStep ] = useState<number>(0);
    const [ process, setProcess ] = useState({
        terms : false, education : false //문진표삭제 요청으로 주석처리 /*, survey : false*/ //, certificate : false
    });
    const [ visitorInfo, setVisitorInfo ] = useState<any>();

    function nextStepHandler() {
        setStep(step+1);
    }

    function policyCompleteHandler(visitorTermsInfos) {
        Api.createVisitorTerms(
            visitorInfo.seq, visitorTermsInfos
        ).then(res => {

        })
        setStep(step+1);
    }

    function completeWithChangeStatusHandler() {
        VisitApi.visitorInfoChangeStatus(visitorInfo.seq, '미승인').then(res => {
            nextStepHandler();
        });
    }
    //문진표 삭제로 인한 내방객이 이미 방문 교육을 들은 경우 즉시 조건미충족에서 미승인으로 수정
    function changeStatusEduskip(seq) {
        VisitApi.visitorInfoChangeStatus(seq, '미승인').then(res => {
            nextStepHandler();
        });
    }

    useEffect(() => {
        if(match.params.visitorInfoSeq!==undefined) {
            Api.getVisitorInfo2(match.params.visitorInfoSeq).then(res => {
                if(localStorage.getItem('siteInfo')==null) {
                    localStorage.setItem('siteInfo', JSON.stringify(res.data.visitorApplicationInfo.hostInfo.siteInfo))
                    window.location.reload();
                }
                setVisitorInfo(res.data);
                //다른 step변수와 꼬이지 않게 변수명을 다르게 바꿈
                let pstep = 0;
                if(res.data.visitorTermsInfos.length > 0) {
                    if(pstep == 0) pstep++;
                    setProcess({...process, terms: true});
                }
                //교육을 과거에 들은 기록이 있으면 step 증가 없으면 방문교육 후 step 증가
                if(res.data.visitorEducationInfos.length > 0) {
                    if(pstep == 1) pstep++;
                }
                /*문진표 삭제 후 교육스킵되는 내방객의 상태변경을 위한 스텝 (방문교육을 들었거나 들은 후 pstep2로 와서 process false면 true로 설정 후 step 증가 true인 경우 pstep 증가 */
                if(pstep == 2){
                    if(process.education == false){
                        changeStatusEduskip(res.data.seq);
                        setProcess({...process, education: true});
                        pstep++;
                    }else{
                        pstep++;
                    }
                }
                setStep(pstep);
            })
        }
    }, [step])

    return (
        <div className="nv_contents">
            <h2 className="nv_subtit" id="top">내방 승인 신청</h2>
            <ul className="nv_step">
                <li className={step === 0 ? 'on' :  ''}>약관동의</li>
                <li className={step === 1 ? 'on' :  ''}>방문교육</li>
                {/*문진표삭제요청으로 3->2 step으로 수정*/}
                <li className={step === 2 ? 'on' :  ''}>승인신청완료</li>
            </ul>
            <div className="nv_step_contents">
                {
                    (localStorage.getItem('siteInfo') !== null && step === 0 && !process.terms) &&
                        <Policy visitorInfo={visitorInfo} setVisitorInfo={setVisitorInfo} nextStepHandler={policyCompleteHandler}/>
                }
                {
                    (localStorage.getItem('siteInfo') !== null && step === 1 && !process.education) &&
                        <div style={{padding: '50px 0'}}>
                            {
                                JSON.parse(localStorage.getItem('siteInfo')).name === '솔브레인에스엘디'
                                    ? <EducationComponentForSld visitorInfo={visitorInfo} educationCompleteHandler={nextStepHandler}/>
                                    : <EducationComponent visitorInfo={visitorInfo} educationCompleteHandler={nextStepHandler}/>
                            }
                        </div>
                }
                {localStorage.getItem('siteInfo') !== null && step === 3 &&  <Complete visitorInfo={visitorInfo}/>}
            </div>
        </div>
    )
}

// 문자로 들어오는 경로
export function VisitorApplicationExtendsForSurveyInfo(props) {
    const {history, match} = props;
    const [ step, setStep ] = useState<number>(0);
    const [ visitorInfo, setVisitorInfo ] = useState<any>();

    function nextStepHandler() {
        setStep(step+1);
    }

    function completeWithChangeStatusHandler() {
        nextStepHandler();
    }

    useEffect(() => {
        if(match.params.visitorInfoSeq!==undefined) {
            Api.getVisitorInfo2(match.params.visitorInfoSeq).then(res => {
                if(localStorage.getItem('siteInfo')==null) {
                    localStorage.setItem('siteInfo', JSON.stringify(res.data.visitorApplicationInfo.hostInfo.siteInfo))
                    window.location.reload();
                }
                setVisitorInfo(res.data);
                setStep(2);
            })
        }
    }, [])

    return (
        <div className="nv_contents">
            <h2 className="nv_subtit" id="top">내방 신청</h2>
            <ul className="nv_step">
                <li className={step === 0 ? 'on' :  ''}>약관동의</li>
                <li className={step === 1 ? 'on' :  ''}>방문교육</li>
                <li className={step === 2 ? 'on' :  ''}>완료</li>
            </ul>
            <div className="nv_step_contents">
                {localStorage.getItem('siteInfo') !== null && step === 2 && <Complete visitorInfo={visitorInfo}/>}
            </div>
        </div>
    )
}

function Complete({visitorInfo}) {

    const [ completeVisitorInfo, setCompleteVisitorInfo ] = useState();

    useEffect(() => {
        Api.getVisitorInfo(
            visitorInfo.seq,
        ).then(res => {
            setCompleteVisitorInfo(res.data);
        } )
    }, [])

    return (
        <section id="step3" className="nv_complete">
            <div style={{padding: '50px 0'}}>
                <VisitorHistoryViewComponent visitorInfo={completeVisitorInfo}/>
            </div>
            <p className="nv_complete_message">
                내방신청이 접수되었습니다.
                <b>감사합니다.</b>
            </p>
            <div className="nv_btn_area">
                <Link to={"/visit"}><button type="button" className="nv_btn_black">메인으로</button></Link>
            </div>
        </section>
    )
}